export enum SiteAmenityTypes {
	BABY_CHANGING_FACILITIES = 'Baby changing facilities',
	BBQ = 'BBQ',
	BUS = 'Bus',
	PARKING = 'Parking',
	SHADE = 'Shade',
	SHOWERS = 'Showers',
	TOILETS = 'Toilets',
}


export interface SiteAmenityModel {
	Name: string;
    ImageName? : string;    
}


export const SiteAmenitiesList : SiteAmenityModel[] = [
	{ Name: SiteAmenityTypes.TOILETS, ImageName: 'wc.svg' },
	{ Name: SiteAmenityTypes.BUS, ImageName: 'departure_board.svg' },
	{ Name: SiteAmenityTypes.SHOWERS, ImageName: 'shower.svg' },
	{ Name: SiteAmenityTypes.SHADE, ImageName: 'deck-shade.svg' },
	{
		Name: SiteAmenityTypes.BABY_CHANGING_FACILITIES,
		ImageName: 'baby_changing_station.svg',
	},
	{ Name: SiteAmenityTypes.BBQ, ImageName: 'outdoor_grill.svg' },
	{ Name: SiteAmenityTypes.PARKING, ImageName: 'local_parking.svg' }
];


